import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  PurchaseAddress,
  PurchaseImportPageFormValues,
} from '@/pages/MovementsPage/PurchaseImportPage';
import { usePurchaseImportFileContext } from '@/pages/MovementsPage/PurchaseImportPage/PurchaseImportFileProvider';
import { applyMask } from '@/utils/mask';
import { cnpjMask } from '@/utils/mask/commonMasks';
import {
  Col,
  Descriptions,
  Divider,
  Form,
  FormInstance,
  Row,
  Select,
} from 'antd';

interface Props {
  address: PurchaseAddress;
  form: FormInstance<PurchaseImportPageFormValues>;
}

export default function PurchaseImportDescriptions({ address, form }: Props) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const { purchaseImportData } = usePurchaseImportFileContext();

  const hasOneCompany = purchaseImportData?.companies.length === 1;

  const companies = purchaseImportData?.companies;

  return (
    <>
      {hasOneCompany ? (
        <>
          <Descriptions
            labelStyle={{ fontWeight: 'bold' }}
            bordered
            layout="vertical"
            size="small"
          >
            <Descriptions.Item label="Destinatário" span={2}>
              {companies?.at(-1)?.name}
            </Descriptions.Item>

            <Descriptions.Item label="CNPJ" span={2}>
              {applyMask(companies?.at(-1)?.cnpj, cnpjMask)}
            </Descriptions.Item>
          </Descriptions>

          <Divider />
        </>
      ) : (
        <Form form={form}>
          <Row>
            <Col span={24} md={12}>
              <FloatingFormItem
                label="Selecione uma empresa"
                initialValue={undefined}
                name="companyId"
                rules={[defaultEmptyFieldError]}
              >
                <Select
                  allowClear
                  options={companies?.map((company) => ({
                    label: company.name,
                    value: company.id,
                  }))}
                />
              </FloatingFormItem>
            </Col>
          </Row>
        </Form>
      )}

      <Descriptions
        labelStyle={{ fontWeight: 'bold' }}
        bordered
        layout="vertical"
        size="small"
      >
        <Descriptions.Item label="Emitente XML" span={2}>
          {purchaseImportData?.supplierDTO.name}
        </Descriptions.Item>

        <Descriptions.Item label="CNPJ" span={2}>
          {applyMask(purchaseImportData?.supplierDTO.cnpj, cnpjMask)}
        </Descriptions.Item>

        <Descriptions.Item
          label="Endereço"
          span={4}
          contentStyle={{ textTransform: 'capitalize' }}
        >
          {purchaseImportData?.supplierDTO.address?.street && (
            <span>{`${purchaseImportData.supplierDTO.address.street.toLowerCase()}, `}</span>
          )}

          {purchaseImportData?.supplierDTO.address?.number && (
            <span>{`Nº ${purchaseImportData.supplierDTO.address.number}, `}</span>
          )}

          {purchaseImportData?.supplierDTO.address?.district && (
            <span>{`Bairro ${purchaseImportData.supplierDTO.address.district.toLowerCase()}, `}</span>
          )}

          {address?.city && <span>{`${address.city} - `}</span>}

          {address?.state && <span>{`${address.state}`}</span>}

          {purchaseImportData?.supplierDTO.address.complement && (
            <span>{`, ${purchaseImportData?.supplierDTO.address.complement}`}</span>
          )}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
}
